import React, { useCallback, useEffect, useState } from "react";
import InputTextField from "../../../components/input/inputTextField";
import { Typography, useMediaQuery, useTheme } from "@mui/material";
import TableCustom from "../../../components/table/tableCustom";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { useDispatch, useSelector } from "react-redux";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { routeName } from "../../../routes/routeName";
import { RemoveRedEyeOutlined, SearchOutlined } from "@mui/icons-material";
import { ButtonPrimary } from "../../../components/button/ButtonCustoms";
import NavigateListCustom from "../../../components/navigation/NavigationListCustom";
import { useParams } from "react-router-dom";
import ModalQuotaHoliday from "../online-leave-submission/components/modal/ModalQuotaHoliday";
import CheckBoxCustom from "../../../components/checkbox/CheckBoxCustom";
import { settingLeavePeriodApi } from "../../../api/setting-leave-period/setting-leave-period.api";
import { dateToView } from "../../../utils/date.utils";
import { EmployeeApi } from "../../../api/employee/employee.api";
import { checkPermission, debouncedApiCall, renderDate } from "../../../utils/app.utils";
import { OrganizationApi } from "../../../api/organization/organization.api";
import StateComponents from "../../../components/state-component/StateComponents";
import { listType, PositionApi } from "../../../api/position/position.api";
import moment from "moment";
import { RootState } from "../../../store/store";
import { useTranslation } from "react-i18next";

type Props = {};

const SettingLeaveDayDetail: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { id } = useParams();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));

  const profileReducer = useSelector((state: RootState) => state.profile.profile);
  const permission: any[] = profileReducer?.permission || [];
  const checkPermit = checkPermission('SettingLeaveDay', permission);

  const [dataSettingLeaveDay, setDataSettingLeaveDay] = useState<any[]>([]);
  const [dataSingleSettingLeaveDay, setDataSingleSettingLeaveDay] =
    useState<any>({
      id_leave_period: 0,
      leave_period: "",
      leave_period_start: "",
      leave_period_end: "",
      status: "",
    });

  const [inputValueSearch, setInputValueSearch] = useState({
    year: "",
    period_date: [],
  });
  const [dataEmployee, setDataEmployee] = useState<any[]>([]);

  const [idEmployee, setIdEmployee] = useState<any[]>([]);
  const [employeeInfo, setIdEmployeeInfo] = useState<any>({});



  const [search, set_search] = useState<string>("");
  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(
    dataSettingLeaveDay.length
  );
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");
  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy);
    setSortType(sortType);
  };

  const [isShowModalQuotaHoliday, setIsShowModalQuotaHoliday] =
    useState<boolean>(false);
  const [isShowModalQuotaHolidayAll, setIsShowModalQuotaHolidayAll] =
    useState<boolean>(false);

  const [isCheckAll, setIsCheckAll] = useState(false);

  // Handle individual checkbox change
  const handleCheckboxChange = (id: number, isChecked: boolean) => {
    setIdEmployee(
      (prevSelected) =>
        isChecked
          ? [...prevSelected, id] // Add the id if checked
          : prevSelected.filter((item) => item !== id) // Remove the id if unchecked
    );
  };

  // Handle "Check All" functionality
  const handleCheckAll = (isChecked: boolean, data: any[]) => {
    if (isChecked) {
      const allIds = data.map((item) => item?.id_employee); // Collect all ids
      setIdEmployee(allIds);
    } else {
      setIdEmployee([]);
    }
    setIsCheckAll(isChecked);
  };

  // const getLeaveEmployeeList = async (id: number) => {
  //   const param = {
  //     page: page,
  //     limit: pageLimit,
  //     sortBy: sortBy,
  //     sortType: sortType,
  //   };
  //   const res = await settingLeavePeriodApi.getLeaveEmployeeList(id, param);
  //   const data = res.data;
  //   if (data.status < 300 && data.data && data.data.items.length > 0) {
  //     setDataSettingLeaveDay(data.data.items);
  //   } else {
  //     setDataSettingLeaveDay([]);
  //   }
  // };

  const getSingleSettinLeavePeriod = async (id: number) => {
    const res = await settingLeavePeriodApi.getLeavePeriodById(id);
    const data = res.data;
    if (data.status < 300 && data.data) {
      setDataSingleSettingLeaveDay(data.data);
    } else {
      setDataSingleSettingLeaveDay({});
    }
  };

  useEffect(() => {
    if (id) {
      getSingleSettinLeavePeriod(+id);
    }
  }, [id]);

  // useEffect(() => {
  //   if (id) {
  //     getLeaveEmployeeList(+id);
  //   }
  // }, [id, page, pageLimit, sortBy, sortType]);

  const headCells = [
    {
      id: "id_leave_time",
      width: 2,
      disablePadding: false,
      align: "center",
      label: (
        <CheckBoxCustom
          checked={isCheckAll}
          setChecked={
            (status: boolean) => handleCheckAll(status, dataEmployee) // Handle check all
          }
        />
      ),
    },
    {
      id: "fullname",
      width: 100,
      disablePadding: false,
      align: "start",
      label: t("ชื่อ-นามสกุล"),
    },
    {
      id: "employee_no",
      disablePadding: false,
      width: 75,
      align: "center",
      label: t("เลขประจำตัวเจ้าหน้าที่"),
    },
    {
      id: "buddhist_name",
      disablePadding: false,
      align: "center",
      width: 50,
      label: t("ฉายา"),
    },
    {
      id: "department",
      disablePadding: false,
      align: "center",
      width: 120,
      label: t("หน่วยงาน"),
    },
    {
      id: "position",
      disablePadding: false,
      align: "center",
      width: 120,
      label: t("ตำแหน่งงาน"),
    },
    {
      id: "age",
      disablePadding: false,
      align: "center",
      width: 50,
      label: t("อายุงาน"),
    },
    // {
    //   id: "work_experience",
    //   disablePadding: false,
    //   align: "center",
    //   width: 50,
    //   label: "สถานะ",
    // },
    {
      id: "user_updated",
      disablePadding: false,
      align: "center",
      width: 100,
      label: t("ผู้สร้าง/ปรับปรุงล่าสุด"),
    },
    {
      id: "last_updated",
      disablePadding: false,
      align: "center",
      width: 100,
      label: t("วันที่สร้าง/ปรับปรุงล่าสุด"),
    },
    {
      id: "action",
      disablePadding: false,
      align: "center",
      class: matches && dataEmployee?.length > 0,
      width: 50,
      label: "action",
    },
  ];

  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const {
      id_employee,
      employee_no,
      department,
      modified_id,
      created_id,
      fullname,
      position_name,
      buddhist_name,
      department_eng,
      modified_date,
      create_date,
      date_start_work,
      date_end_work
      // department
    } = objData;

    const isChecked = idEmployee.includes(id_employee);

    const text_work_ex = date_start_work ? work_experience_cal(date_start_work, date_end_work) : "-"
    const objRenderData = {
      key: id_employee,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "center",
          label: (
            <CheckBoxCustom
              checked={isChecked}
              setChecked={(status: boolean) =>
                handleCheckboxChange(id_employee, status)
              }
            />
          ),
        },
        {
          option: "TEXT",
          align: "start",
          // label: first_name + " " + last_name,
          label: fullname,
        },
        {
          option: "TEXT",
          align: "center",
          label: employee_no,
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: buddhist_name || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: department || department_eng || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: position_name || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: text_work_ex,
        },
        {
          option: "TEXT",
          align: "center",
          label: modified_id || created_id || "-",
        },
        {
          option: "TEXT",
          align: "center",
          label: modified_date ? renderDate(modified_date) : create_date ? renderDate(modified_date) : "-",
        },
        {
          option: "COMPONENT",
          align: "center",
          class: matches,
          component: (
            <>
              {checkPermit.isView && (
                <RemoveRedEyeOutlined
                  onClick={() => {
                    setIsShowModalQuotaHoliday(true);
                    setIdEmployee([id_employee]);
                    setIdEmployeeInfo({
                      ...objData,
                      title: fullname,
                      position_name: position_name,
                      department_name_th: department,
                    });
                  }}
                  style={{
                    cursor: "pointer",
                  }}
                />
              )}
            </>
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };


  const work_experience_cal = (start_date: string, end_date?: string): string => {
    const start = moment(start_date);
    const now = end_date ? moment(end_date) : moment();
    let result = "";
    const years = now.diff(start, "years");
    if (years > 0) {
      result = t("{{years}} ปี", { years });
    } else {
      const months = now.diff(start, "months");
      if (months > 0) {
        result = t("{{months}} เดือน", { months });
      } else {
        const days = now.diff(start, "days");
        result = t("{{days}} วัน", { days });
      }
    }
    return result
  }

  useEffect(() => {
    dispatch(setLoading());
    setTimeout(() => {
      dispatch(unsetLoading());
    }, 500);
  }, []);

  const [department_list, set_department_list] = useState<any[]>([]);
  const [id_department, set_id_department] = useState<any>(null);
  const [search_department, set_search_department] = useState<string>("");
  const [position_list, set_position_list] = useState<any[]>([]);
  const [id_position, set_id_position] = useState<any>(null);
  const [search_position, set_search_position] = useState<string>("");

  const getEmployee = useCallback(async () => {
    let query: {
      page: number;
      limit: number;
      sortBy?: string;
      sortType?: string;
      department?: number;
      search?: string;
      position?: number;
    } = {
      page: page,
      limit: 1000000,
      sortBy: sortBy,
      sortType: sortType,
    };
    if (id_department) query.department = id_department?.id_department;
    if (id_position) query.position = id_position?.id_position
    if (search) query.search = search
    const res = await EmployeeApi.list(query);
    const data = res.data;
    if (data.status < 300 && data.data && data.data.items.length > 0) {
      setTotalItems(res.data?.data?.meta?.totalItems || 0);
      setDataEmployee(data.data.items);
    } else {
      setDataEmployee([]);
    }
  }, [id_department, sortBy, sortType, search, id_position])




  const handleGetDepartmentList = useCallback(async () => {
    let query: { keyword?: string } = {};
    if (search_department) query.keyword = search_department
    await OrganizationApi.list(query).then((res) => {
      if (res.status < 300) {
        const response = res.data?.data || [];
        set_department_list(response);
      }
    }).catch((err) => {
      console.log(err)
    })
  }, [search_department])

  const handleGePositionList = useCallback(async () => {
    let query: listType = {};
    if (search_position) query.position_name = search_position
    await PositionApi.list(query).then((res) => {
      if (res.status < 300) {
        const response = res.data?.data?.items || [];
        set_position_list(response);
      }
    }).catch((err) => {
      console.log(err)
    })
  }, [search_position])


  useEffect(() => {
    handleGetDepartmentList();
  }, [handleGetDepartmentList])
  useEffect(() => {
    handleGePositionList();
  }, [handleGePositionList])


  useEffect(() => {
    getEmployee();
  }, [getEmployee]);






  return (
    <div className="h-auto">
      <ModalQuotaHoliday
        is_update={true}
        is_all={false}
        data={dataEmployee}
        setIsOpenModal={(isOpen: boolean) => setIsShowModalQuotaHoliday(isOpen)}
        isOpenModal={isShowModalQuotaHoliday}
        idEmployee={idEmployee}
        period_id={id ? +id : 0}
        employeeInfo={employeeInfo}
      />

      <ModalQuotaHoliday
        is_update={true}
        is_all={true}
        data={dataEmployee}
        setIsOpenModal={(isOpen: boolean) =>
          setIsShowModalQuotaHolidayAll(isOpen)
        }
        isOpenModal={isShowModalQuotaHolidayAll}
        idEmployee={idEmployee}
        period_id={id ? +id : 0}
        employeeInfo={employeeInfo}
      />

      {/* breadcrumbs */}
      <NavigateListCustom
        navigateData={[
          {
            name: t("ตั้งค่าวันลา"),
            key: "1",
            pathName: routeName.cms.SettingLeaveDay,
          },
          {
            name: `${t("รอบปี")} ${dataSingleSettingLeaveDay.leave_period} ${dateToView(
              dataSingleSettingLeaveDay.leave_period_start
            )}-${dateToView(dataSingleSettingLeaveDay.leave_period_end)}`,
            key: "2",
            pathName: routeName.cms.SettingLeaveDay + `/${id}/detail`,
          },
        ]}
      />

      {/* header */}
      <section className="my-4">
        <Typography variant="h3">
          {`${t("รอบปี")} ${dataSingleSettingLeaveDay.leave_period} ${dateToView(
            dataSingleSettingLeaveDay.leave_period_start
          )}-${dateToView(dataSingleSettingLeaveDay.leave_period_end)}`}
        </Typography>
      </section>

      <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        <article className="w-full sm:col-span-12 md:col-span-3 lg:col-span-3">
          <InputTextField
            startAdornment={<SearchOutlined />}
            placeholder={t("ค้นหาชื่อ - นามสกุล/ชื่อฉายา")}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
              debouncedApiCall({ setItem: set_search, searchItem: e.target.value })
              // handleChangeValueSearch("name", e.target.value);
            }}
          // value={inputValueSearch.name}
          />
        </article>

        <article className="sm:col-span-12 md:col-span-3 lg:col-span-3">
          {/* <FilterSelect
            value={""}
            // renderValue={() => "ทุกสถานะ"}
            labelId="department-id"
            selectId="department-select-id"
            options={[]}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChangeValueSearch("department", e.target.value)
            }
          /> */}
          <StateComponents
            typeProps={[
              {
                seq: 1,
                type: "AUTO-COMPLETE",
                gridProps: {
                  xs: 12
                },
                fieldProps: {
                  placeholder: t("ทุกหน่วยงาน"),
                  getOptionLabel: (op) => op?.department_name_th || op?.department_name_eng || "",
                  labelId: "id_department",
                  onInputChange: (_: any, val: string) => debouncedApiCall({ searchItem: val, setItem: set_search_department }),
                  onChange: (_, val) => set_id_department(val ?? null),
                  options: department_list || [],
                  value: id_department || null
                }
              }
            ]}
          />
        </article>
        <article className="sm:col-span-12 md:col-span-3 lg:col-span-3">
          {/* <FilterSelect
            value={""}
            // renderValue={() => "ทุกสถานะ"}
            labelId="position-id"
            selectId="position-select-id"
            options={[]}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChangeValueSearch("position", e.target.value)
            }
          /> */}
          <StateComponents
            typeProps={[
              {
                seq: 1,
                type: "AUTO-COMPLETE",
                gridProps: {
                  xs: 12
                },
                fieldProps: {
                  placeholder: t("ทุกตำแหน่ง"),
                  getOptionLabel: (op) => op?.position_name || "",
                  labelId: "id_position",
                  onInputChange: (_: any, val: string) => debouncedApiCall({ searchItem: val, setItem: set_search_position }),
                  onChange: (_, val) => set_id_position(val ?? null),
                  options: position_list || [],
                  value: id_position || null
                }
              }
            ]}
          />
        </article>

        <article className="sm:col-span-12 md:col-span-3 lg:col-span-3">
          {checkPermit.isUpdate && (
            <ButtonPrimary
              mode="next"
              onClick={() => {
                setIsShowModalQuotaHolidayAll(true);
              }}
              buttonName={t("ตั้งค่าจำนวนวันลา")}
              disabled={idEmployee.length === 0}
              btnProps={{
                width: "150px",
              }}
            />
          )}
        </article>
      </div>

      <section className="w-full mt-10">
        <TableCustom
          tableMinWidth={1920}
          tableFixedWidth
          customScroll
          page={page}
          pageLimit={pageLimit}
          sortBy={sortBy}
          sortType={sortType}
          headCells={headCells}
          rowCount={totalItems}
          rowsData={
            dataEmployee?.slice(
              (page - 1) * pageLimit,
              ((page - 1) * pageLimit) + pageLimit
            ).map((data: any, i: any) => {
              return renderData(data, i);
            })
          }
          onSort={handleRequestSort}
          setPageLimit={(value: number) => setPageLimit(value)}
          setPage={(value: number) => setPage(value)}
        />
      </section>
    </div>
  );
};

export default SettingLeaveDayDetail;
